/**
 * @format
 */

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import SalesSummaryContainer from 'features/dashboard/containers/SalesSummaryContainer';
import MonthlySalesChartContainer from 'features/dashboard/containers/MonthlySalesChartContainer';
import WeeklyPremiumContainer from 'features/dashboard/containers/WeeklyPremiumContainer';
import { getDashboardParamsByRole } from 'features/dashboard/utils/roleUtils';
import { Layout } from 'features/layout';

const Dashboard: React.FC = () => {
  const user = useSelector((state: RootState) => (state.user as any).userData);

  // Get params based on user role
  const params = useMemo(() => {
    return getDashboardParamsByRole(user);
  }, [user]);

  return (
    <Layout>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <SalesSummaryContainer params={params} />
        <MonthlySalesChartContainer params={params} />
        <WeeklyPremiumContainer params={params} />
      </div>
    </Layout>
  );
};

export default Dashboard;
